import type { Organization, Role, User } from '../types/api';
import i18n from '../i18n';

export function shortId(id: string, length = 8): string {
    if (!id) {
        return i18n.t('common.empty');
    }
    return id.length <= length + 1 ? id : `${id.slice(0, length)}…`;
}

export function userLabel(
    user?: Pick<User, 'firstName' | 'lastName' | 'email' | 'id'> | Partial<User> | null,
): string {
    if (!user) {
        return '';
    }
    const name = [user.firstName, user.lastName].filter(Boolean).join(' ').trim();
    if (name) {
        return name;
    }
    if (user.email) {
        return user.email;
    }
    if (user.id) {
        return shortId(user.id);
    }
    return '';
}

export function organizationLabel(org?: Pick<Organization, 'name' | 'id'> | null): string {
    if (!org) {
        return '';
    }
    return org.name || shortId(org.id);
}

export function roleLabel(role?: Pick<Role, 'name' | 'displayName' | 'scope' | 'id'> | null): string {
    if (!role) {
        return '';
    }
    const scope = role.scope ? ` (${role.scope})` : '';
    const label = role.displayName || role.name;
    return `${label}${scope}` || shortId(role.id);
}

export function entityTypeLabel(entityType: string): string {
    return entityType.replace(/_/g, ' ');
}
